module.exports = __webpack_public_path__ + "static/media/sextent.2568b4d5.svg";